module.exports = __webpack_public_path__ + "static/img/defalutimg.70157f32.png";